import React from 'react';
const TabActionButton = ({
  tooltipText = '',
  buttonCss = '',
  buttonColor = '',
  onActionButtonClick = () =>{},
  items = '',
  apiService = '',
}) => {
  return (
    <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
      <div className='tootip_box'> {tooltipText} </div>
      <i
        onClick={() => onActionButtonClick(apiService, items)}
        className={buttonCss}
        style={{ color: buttonColor }}
      >
      </i>
    </span>
  );
};
export default TabActionButton;



// WEBPACK FOOTER //
// ./src/Components-2025/dashboard/TabActionButton.jsx